import React, { useEffect, useState } from "react";
import {
  getLoadStopDetails,
  FireBaseLogEvent,
  LPEFeedBackLogEvent,
} from "../utils";
import { useHistory } from "react-router";
import * as Constants from "../../../../../utils/constants";
import {
  MODULES,
  Navigate_Module,
  WATCHED_TAB,
  RECOMMENDED_TAB,
  SEARCH_TITLE,
  BOOKLOAD_STATUS_OK,
  APPOINTMENT_MODAL_TITLE,
  APPOINTMENT_MODAL_MESSAGE,
  APPOINTMENT_INDICATOR_STATE_VALUE,
  SAME_DAY_PICKUP_POPUP_MESSAGE,
  SAME_DAY_PICKUP_POPUP_TITLE,
  SAME_DAY_PICKUP_MODAL_TYPE,
  APPOINTMENT_MODAL_TYPE,
  GENERIC_PRE_BOOK_NOW_POPUP_TITLE,
  GENERIC_PRE_BOOK_NOW_POPUP_MESSAGE,
  CONTACT_DETAILS_NOT_FOUND,
} from "../../../../../utils/constants";
import { EVENT, SCREEN } from "../../../../../utils/constants.analytics";
import { BookLoadModal } from "../../../../components/common/BookLoadModal/BookLoadModal";
import { BookLoadConfirmModal } from "../../../../components/common/BookLoadModal/BookLoadConfirmModal";
import { BookLoad } from "../../../../../models/home/BookLoad.model";
import { Currency } from "../../../../../schemas/BookLoad/BookLoad.schema";
import { GetShipment } from "../../../../../models/home/GetShipment.model";
import { TopRecommendationProps } from "../types";
import TopRecommendationTile from "../TopRecommendationTile/TopRecommendationTile";
import ContactUsModal from "../../../../../components/shared/ContactUsModal/ContactUsModal";
import { useDispatch, useSelector } from "react-redux";
import GetQualifiedModal from "../../../../../components/shared/GetQualifiedModal/GetQualifiedModal";
import { getUserMasterData } from "../../../../../selectors/selector";
import { IUserDetails } from "../../../../../schemas/user";
import { isElevatedLeasedOwenerOprRole } from "../../../../../utils/roleUtil/RoleUtil";
import { ConfirmDriverDialog } from "../../../../components/assign-driver/ConfirmDriverDialog";
import { getAssignShipmentDriverResponse } from "../../../../../selectors/carrierAssign/selector";
import getTime from "../../../../../utils/getTimePeriod";
import { getPredecessorShipmentPayload } from "../../../../../pages/Execute/AssignDriverList/assignDriver.util";
import { CustomModalWeb } from "../../../userProfile/CustomModalWeb";
import { appointmentState, sameDateFreightCheckValue } from "../../../../../utils/formatData";
import { IONICWrapper } from "../../../../../utils/common";
import { ToastMessage } from "../../../../../utils/ToastMessage";
import { getSessionId, logEvent } from "../../../../../utils/Analytics";
import { store } from "../../../../../store";
import { contactUsDetailsRequest } from "app/actions/myload/action";



const TopRecommendation = (props: TopRecommendationProps) => {
  const { push } = useHistory();
  const {
    rate,
    userDetails,
    sourceSystem,
    loadId,
    getWatchedLoadsData,
    buyAllowed,
    rank,
    resultId,
    isNetworkAvailable,
    getPredecessorShipment
  } = props;
  const loadDetails = getLoadStopDetails(props);
  const [isBookLoadModal, setBookLoadModal] = useState<boolean>(false);
  const [contactUsModal, setContactUsModal] = useState<boolean>(false);
  const [getQualifiedModal, setGetQualifiedModal] = useState<boolean>(false);
  const [bookLoad, setBookLoad] = useState<boolean>(false);
  const [clickType, updateClickType] = useState<string>("");
  const [driverDetails, setDriverDetails] = useState<any>([]);
  const [predecessorShipment, setPredecessorShipment] = useState<any>(null);
  const [shipmentData, setShipmentData] = useState<any>();
  const [showDriverAssignment, setShowDriverAssignment] = useState<boolean>(false);
  const [successorModal, setSuccessorModal] = useState<boolean>(false);  
  const [confirmBookLoadHeader, setConfirmBookLoadHeader] = useState<string>("");
  const assignedDriverResponse: any = useSelector(getAssignShipmentDriverResponse());
  const updateduserDetails : IUserDetails = useSelector(getUserMasterData());
  const [preBookNowModalOpen,setPreBookNowModalOpen] = useState<boolean>(false);
  const [preBookNowModalMessage,setPreBookNowModalMessage] = useState<string>("");
  const [preBookNowModalType,setPreBookNowModalType] = useState<string>("");
  const [loadForModal,setLoadForModal] = useState<any>([]);
  const module = SEARCH_TITLE;
  const storeData = store.getState();
  const session = storeData && storeData.App && storeData.App.session;
  const sessionId = getSessionId(session.uuid);
  const [selectedBookNowId,setselectedBookNowId] = useState<any>("");
  const [contactDetails, setContactDetails] = useState<any>(null);
  const dispatch = useDispatch();
  useEffect(() => {
    if(props.loadId === selectedBookNowId){
    if(props?.bookLoadStatus?.status === BOOKLOAD_STATUS_OK && isElevatedLeasedOwenerOprRole()){
     confirmBookLoad()
    }
    } 
   }, [props?.bookLoadStatus?.status])
  function bookNowClick(event: any,selectedLoadId?: any) {
    setselectedBookNowId(selectedLoadId)
    event.stopPropagation();
    if (props.rate && props.rate.totalCharge && buyAllowed) {
      if(updateduserDetails && updateduserDetails.memberDetailsResponse && updateduserDetails.memberDetailsResponse.carrierInfo && updateduserDetails.memberDetailsResponse.carrierInfo.carrierActiveIndicator === true){
        var message = "";
        var modalType = "";
        if(sameDateFreightCheckValue(props?.loadStop) && appointmentState(props?.loadStop,props) === APPOINTMENT_INDICATOR_STATE_VALUE)
        {
          message = IONICWrapper?.details?.keys?.configuration?.GenericPreBookNowPopUpMessage || GENERIC_PRE_BOOK_NOW_POPUP_MESSAGE;
          modalType = `${SAME_DAY_PICKUP_MODAL_TYPE +"," +APPOINTMENT_MODAL_TYPE}`;
        }
        else if(sameDateFreightCheckValue(props?.loadStop))
        {
          message = IONICWrapper?.details?.keys?.configuration?.SamedayPickupPopupMessage || SAME_DAY_PICKUP_POPUP_MESSAGE;
          modalType = SAME_DAY_PICKUP_MODAL_TYPE;
        }
        else if(appointmentState(props?.loadStop,props) === APPOINTMENT_INDICATOR_STATE_VALUE)
        {
          message = IONICWrapper?.details?.keys?.configuration?.AppointmentModalMessage || APPOINTMENT_MODAL_MESSAGE ;
          modalType = APPOINTMENT_MODAL_TYPE;
        }
        if(message!== "")
        {
           setPreBookNowModalOpen(true)
           setPreBookNowModalMessage(message)
           setPreBookNowModalType(modalType)
           setLoadForModal(props?.loadStop)
           
           logEvent(EVENT.SV_PRE_BOOK_NOW_MODAL, {
            screen:SCREEN.PRE_BOOK_NOW_MODAL,
            loadId: props?.loadId,
            sessionId :sessionId,
            lead: module,
            modalType: preBookNowModalType
          });  
        }
else {setBookLoadModal(true);
      //Book Now event Clicked
      LPEFeedBackLogEvent(
        EVENT.UE_BOOK_LOAD_NOW,
        SCREEN.SEARCH,
        loadId,
        module,
        rank,
        resultId
      );
      // Analytics implementation
      FireBaseLogEvent(
        EVENT.SV_LOAD_DETAILS_RATE,
        SCREEN.SEARCH,
        loadId,
        userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
        module,
        rank,
        resultId
      );
}
    }
  else 
  {
    setGetQualifiedModal(true)
  }
  } else {
    if(updateduserDetails && updateduserDetails.memberDetailsResponse && updateduserDetails.memberDetailsResponse.carrierInfo && updateduserDetails.memberDetailsResponse.carrierInfo.carrierActiveIndicator === true){
        const callback = (responseType: string, data: any) => {
        if (responseType === "success") {
          setContactUsModal(true);
          setContactDetails(data?.message)
        } else {
         ToastMessage.showWeb(CONTACT_DETAILS_NOT_FOUND);
       }
       };
       const payload = props.loadId;
       dispatch(contactUsDetailsRequest({
         query: payload,
         callback
       }))
    }
   else{ 
    setGetQualifiedModal(true)
   }
    }
  }
  const buyLoad = () => {
    const modelLoad: BookLoad = new BookLoad();
    if (isNetworkAvailable || Constants.OFFLINE_MODE_STATE) {
      const data = {
        lhlCharges: (rate && rate.lineHaulCharge.charge) || 0,
        fsrCharges: (rate && rate.fuelCharge.charge) || 0,
        carrierId: (userDetails && userDetails.memberDetailsResponse &&
          userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId) || "",
        userId: (userDetails && userDetails.memberDetailsResponse &&
          userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.upn) || "",
        sourceSystem: sourceSystem || "",
        loadId: loadId,
        amount: rate.totalCharge || 0,
        binRateId: (rate && rate.binRateIdentifier) || "",
        currency: Currency.USD || Currency.CAD,
      };
      props.buyLoadRequest({
        query: modelLoad.getRequestPayload(),
        data,
      });
      //Book Now alert Accepted
      LPEFeedBackLogEvent(
        EVENT.UE_LOAD_RATE_ACCEPT,
        SCREEN.SEARCH,
        loadId,
        module,
        props.rank,
        props.resultId
      );
      // Analytics implementation
      FireBaseLogEvent(
        EVENT.UE_LOAD_RATE_ACCEPT,
        SCREEN.SEARCH,
        loadId,
        userDetails && userDetails.memberDetailsResponse &&
        userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
        module,
        props.rank,
        props.resultId
      );
    } else {
      props.showAlert({
        isShowAlert: true,
        alertMessage: Constants.PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
        alertTitle: Constants.NO_NETWORK,
      });
    }
    setBookLoadModal(false);
  };
  const LO3PostBuyLoadProcess = async (shipmentId: any) => {
    const __getShipmentmodel: GetShipment = new GetShipment();
    __getShipmentmodel.shipmentIds = shipmentId;
    props.buyLoadShipmentRequest(
      {
        query: __getShipmentmodel.getRequestShipmentPayload(),
        shipmentId,
        module: "",
        isPullToRefresh: false,
      },
      (res:any) => {
        const _shipmentData = res?.getShipment?.length > 0 && res?.getShipment[0];
        if(_shipmentData){
        setShipmentData(_shipmentData)
        const DriverData = {...userDetails?.memberDetailsResponse?.member,userPrincipalName:userDetails?.memberDetailsResponse?.member?.upn}
        setDriverDetails(DriverData);
        const payload = getPredecessorShipmentPayload({loadDetails: _shipmentData,driver: DriverData})
        const predecessorCallback = (response:any)=>{
          setShowDriverAssignment(true);
          if(response?.data?.predecessorShipmentId) setPredecessorShipment(response?.data?.predecessorShipmentId);
        }
        props.getPredecessorShipment && props.getPredecessorShipment(payload,predecessorCallback);
      }
      else
      {
        ToastMessage.showWeb(res?.errors && res?.errors[0].message)
        
      }}
    );
  };
  const declineBookLoad = () => {
    setBookLoadModal(false);
    // Analytics implementation
    FireBaseLogEvent(
      EVENT.UE_LOAD_RATE_DENY,
      SCREEN.SEARCH,
      loadId,
      userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
      module
    );
  };
  const calculateTime = (stop: any) => {
    let _newAptTime: string = getTime(
      stop.appointmentFrom || "",
      stop.appointmentTo || ""
    );
    _newAptTime = (_newAptTime || "")
      .split("AM")
      .join("am")
      .split("PM")
      .join("pm")
      .replace(/Z/g, "")
      .replace(/z/g, "");
    return _newAptTime;
  };
  const confirmBookLoad = () => {
    if (props.isNetworkAvailable) {
      if (props.bookLoadStatus.status === Constants.BOOKLOAD_STATUS_OK) {
        if(isElevatedLeasedOwenerOprRole()){
          props?.bookLoadStatus?.message && setConfirmBookLoadHeader(props?.bookLoadStatus?.message?.split("  ").slice(1).join("\n "))
            LO3PostBuyLoadProcess(props?.loadId)
        }
       else{ const shipmentId = props.loadId;
        const shipmentIds: any = [];
        shipmentIds.push(shipmentId);
        const getShipmentmodel: GetShipment = new GetShipment();
        getShipmentmodel.shipmentIds = shipmentIds;
        getShipmentBookLoad(shipmentId);
        props.buyLoadStatusRemove();
       }
        // Analytics implementation
        FireBaseLogEvent(
          EVENT.UE_BOOK_SUCCESS,
          SCREEN.SEARCH,
          loadId,
          userDetails && userDetails.memberDetailsResponse &&
          userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
          module
        );
      }
      if (
        props.bookLoadStatus.status === Constants.BOOKLOAD_ONHOLD ||
        Constants.BOOKLOAD_STATUS_REJECTED
      ) {
        // Analytics implementation
        FireBaseLogEvent(
          EVENT.UE_BOOK_FAILED,
          SCREEN.SEARCH,
          loadId,
          userDetails && userDetails.memberDetailsResponse &&
          userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
          module
        );
      }
      if (props.bookLoadStatus.status === Constants.BOOKLOAD_CANCELLED) {
        removeLoadsFromStore(props.loadId || null);
        ToastMessage.showWeb(props.bookLoadStatus.message)
      }
      if (props.bookLoadStatus.status === Constants.BOOKLOAD_TIMEOUT) {
        push(`${props.module}`);
      }
      props.buyLoadStatusRemove();
      !isElevatedLeasedOwenerOprRole() && props.refreshTopRecommend();
    } else {
      props.showAlert({
        isShowAlert: true,
        alertMessage: Constants.PLEASE_CHECK_NETWORK_CONNECTIVITY_MESSAGE,
        alertTitle: Constants.NO_NETWORK,
      });
    }
  };
  const getShipmentBookLoad = async (shipmentId: any) => {
    const __getShipmentmodel: GetShipment = new GetShipment();
    __getShipmentmodel.shipmentIds = shipmentId;
    props.buyLoadShipmentRequest(
      {
        query: __getShipmentmodel.getRequestShipmentPayload(),
        shipmentId,
        module: "",
        isPullToRefresh: false,
      },
      (res : any) => {
        const _shipmentData = res?.getShipment?.length > 0 && res?.getShipment[0];
        if(_shipmentData){
        setBookLoad(true);
        }
        else
        {
          ToastMessage.showWeb(res?.errors && res?.errors[0].message)
        }
      }
    );
  };
  useEffect(() => {
    const bookedLoad = props.getShipmentDetails;
    if (bookedLoad && bookedLoad.shipments && bookedLoad.shipments.length > 0) {
      /**
       * storing the current path and module before navigation to carrier assigned load details page.
       */
      if (bookLoad) {
        removeLoadsFromStore(props.loadId || null);
        if (clickType === "viewMoreResults") {
          redirectToResults();
        }
        if (clickType === "assignDriver") {
          push(Constants.CARRIER_ASSIGNED_MODULE_WEB, {
            isBookLoad: true,
            shipments: bookedLoad.shipments,
            module: props.module,
            shipmentId: props.loadId,
          });
        }
      }
      setBookLoad(false);
    }
  }, [bookLoad]);
  const removeLoadsFromStore = (loadId: string) => {
    props.removeSearchResults(loadId);
    props.removeRecommendedResults({ loadId });
    props.removewatchedResults({ loadId });
  };
  const redirectToResults = () => {
    return props.module == MODULES.SEARCH_RESULTS
      ? push({
        pathname: `/app/${module}`,
        state: {
          showResults: true,
        },
      })
      : push({
        pathname: Navigate_Module.home,
        state: {
          subSegment: props.module.includes("homewatched")
            ? WATCHED_TAB
            : RECOMMENDED_TAB,
        },
      });
  };
  const clickOnWatch = (event: any) => {
    event.stopPropagation();
    props.onWatchIconClick(props.load);
  };

  const preBookNowModalProps = {
    isModalOpen:  preBookNowModalOpen,
    title: IONICWrapper?.details?.keys?.configuration?.GenericPreBookNowPopUpTitle || GENERIC_PRE_BOOK_NOW_POPUP_TITLE,
    message : preBookNowModalMessage,
    aditionalCssClass : "",
    size: (sameDateFreightCheckValue(loadForModal) && appointmentState(loadForModal,props) === APPOINTMENT_INDICATOR_STATE_VALUE )?"pre_booknow" :"medium_booknow",
    contentScroll: "deny",
    backdropDismiss:false,
    buttons: [
      {
        title: 'Cancel',
        type: "secondary-cta-btn-web",
        onClick: () => {
          setPreBookNowModalOpen(false)
          logEvent(EVENT.UE_PRE_BOOK_NOW_CANCELLATION, {
            screen:SCREEN.SAMEDAY_PICKUP_MODAL,
            loadId: props?.loadId,
            sessionId :sessionId,
            lead: module,
            modalType: preBookNowModalType
          }); 
       }
      },
      {
        title: IONICWrapper?.details?.keys?.configuration?.AppointmentModalButtonName || Constants.APPOINTMENT_MODAL_BUTTON_NAME,
        type: "primary-cta-btn-web",
        onClick: () => {
          setPreBookNowModalOpen(false)
            setBookLoadModal(true)
            logEvent(EVENT.UE_PRE_BOOK_NOW_ACCEPTANCE, {
              screen:SCREEN.SAMEDAY_PICKUP_MODAL,
              loadId: props?.loadId,
              sessionId :sessionId,
              lead: module,
              modalType: preBookNowModalType
            }); 
                //Book Now event Clicked
      LPEFeedBackLogEvent(
        EVENT.UE_BOOK_LOAD_NOW,
        SCREEN.SEARCH,
        loadId,
        module,
        rank,
        resultId
      );
      // Analytics implementation
      FireBaseLogEvent(
        EVENT.SV_LOAD_DETAILS_RATE,
        SCREEN.SEARCH,
        loadId,
        userDetails && userDetails.memberDetailsResponse &&
      userDetails.memberDetailsResponse.member && userDetails.memberDetailsResponse.member.carrierId,
        module,
        rank,
        resultId
      );

       }
      }
    ]
  };

  return (
    loadDetails && (
      <>
      <CustomModalWeb {...preBookNowModalProps}/> 
        <TopRecommendationTile
          {...props}
          loadDetails={loadDetails}
          bookNowClick={bookNowClick}
          clickOnWatch={clickOnWatch}
          getWatchedLoadsData={getWatchedLoadsData}
          loadId={loadId}
          onCardClick={props.onCardClick}
        />
        {isBookLoadModal ? (
          <BookLoadModal
            isBookLoadModal={isBookLoadModal}
            bookedDetails={props.rate}
            buyLoad={buyLoad}
            declineBookLoad={declineBookLoad}
            carrierId={{}}
            lead="true"
            loadId={props.loadId}
            isManaged={props.managedEquipment || false}
          />
        ) : getQualifiedModal ? (
          <GetQualifiedModal
            isOpen={getQualifiedModal}
            onClosed={() => setGetQualifiedModal(false)}
          />
        ) : contactUsModal ?<ContactUsModal
        isOpen={contactUsModal}
        onClosed={() => setContactUsModal(false)}
        contactDetails={contactDetails}
      />:null}
        {showDriverAssignment && isElevatedLeasedOwenerOprRole() ?
          <ConfirmDriverDialog
            userDetails={props.userDetails}
            driverDetails={driverDetails}
            open={showDriverAssignment}
            onDismiss={(cancle: boolean) => {
              setShowDriverAssignment(false);
            }}
            loadDetails={{ ...props, ...shipmentData }}
            loadData={props?.loadData}
            calculateTime={calculateTime}
            count={null}
            module={""}
            predecessorShipmentDetails={predecessorShipment}
            isLo3User={isElevatedLeasedOwenerOprRole()}
            header={confirmBookLoadHeader}
            handleReloadPopup={() => {
              setShowDriverAssignment(false)
              setSuccessorModal(true)
              props.buyLoadStatusRemove();
            }}
          />
           : props.bookLoadStatus &&
           props.bookLoadStatus?.status &&
           props.bookLoadStatus.message ? (
            <BookLoadConfirmModal
              confirmModal={!!props.bookLoadStatus.status}
              bookLoadResponse={props.bookLoadStatus}
              confirmBookLoad={confirmBookLoad}
              loadId={props.isTopRecomm ? selectedBookNowId : props.loadId}
              updateClickType={updateClickType}
            />
          ): null}
      </>
    )
  );
};
export default TopRecommendation;